import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'ras-map',
	templateUrl: './map.component.html',
	styleUrls: ['./map.component.sass']
})
export class MapComponent implements OnInit {

	public show: boolean = false
	@Input('show') set _show(value) {
		this.show = value
		if (value) this.shown = true
	}

	@Input() url: string
	public shown = false

	constructor() { }

	ngOnInit() {
	}

}
